import React from "react";

const statusConfig = {
  connected: {
    label: "Conectado",
    color: "bg-green-100 text-green-800 border-green-300",
    icon: "✅",
  },
  awaiting_scan: {
    label: "Aguardando QR Code",
    color: "bg-yellow-100 text-yellow-800 border-yellow-300",
    icon: "⏳",
  },
  disconnected: {
    label: "Desconectado",
    color: "bg-red-100 text-red-800 border-red-300",
    icon: "❌",
  },
  connecting: {
    label: "Conectando...",
    color: "bg-blue-100 text-blue-800 border-blue-300",
    icon: "🔄",
  },
};

export const WhatsAppStatus = ({ status }) => {
  const config = statusConfig[status] || statusConfig.disconnected;

  return (
    <div
      className={`inline-flex items-center px-3 py-1 rounded-full border ${config.color}`}
    >
      <span className="mr-2">{config.icon}</span>
      <span className="text-sm font-medium">{config.label}</span>
    </div>
  );
};
